'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var error = {
  1: '[api-book] Book needs to have property of url.',
  2: '[api-book] Book needs to have property of method.'
};

exports.default = error;


//////////////////
// WEBPACK FOOTER
// ./node_modules/api-book/lib/error.js
// module id = 185
// module chunks = 0